import React from "react"
import {
  ActionRow,
  BlockingIcon,
  Comment,
  IconWrapper,
  InformativeIcon,
  Reference,
  SmallInfo,
  StateDate
} from "./CustomerOrderTable.styled"
import dayjs from "dayjs"
import { CustomStateType, OrderHistoryLogEntry } from "lib/types/generated/graphql-types"
import { CustomerOrders } from "../../classes/customer/CustomerOrders"
import { ReactComponent as XmarkIcon } from "images/icons/xmark-thick.svg"
import { ReactComponent as InfoIcon } from "images/icons/info-thick.svg"
import { Tooltip } from "react-tooltip"
import { formatOperation } from "../Order/helpers"

type Props = {
  customerOrders: CustomerOrders
  entry: OrderHistoryLogEntry
}

const CustomStateRow = ({ customerOrders, entry }: Props) => {
  const customState = customerOrders.getCustomState(entry.operationId)

  return (
    <ActionRow>
      <Reference>
        <IconWrapper>
          {customState?.type === CustomStateType.Blocking ? (
            <>
              {" "}
              <Tooltip id={entry.operationId}>
                {customState?.operations && customState?.operations?.length > 0 ? (
                  <div>
                    {customState?.operations?.map((operation) => (
                      <div key={operation}>{formatOperation(operation ?? "")}</div>
                    ))}
                  </div>
                ) : (
                  <div>No blocking operations</div>
                )}
              </Tooltip>
              <BlockingIcon data-tooltip-id={entry.operationId}>
                <XmarkIcon />
              </BlockingIcon>
            </>
          ) : (
            <InformativeIcon>
              <InfoIcon />
            </InformativeIcon>
          )}
        </IconWrapper>
        <Comment>
          <b>{customState?.description}</b>
          <SmallInfo>{entry?.actor?.name}</SmallInfo>
        </Comment>
      </Reference>
      <StateDate className={"hideOnSmallScreens"}>
        <div>
          <span>
            <b>{dayjs(entry?.timestamp).format("YYYY-MM-DD")}</b>
          </span>
          <span>{dayjs(entry?.timestamp).format("HH:mm")}</span>
        </div>
      </StateDate>
    </ActionRow>
  )
}

export default CustomStateRow
